import React, {useState} from 'react';
import DevicesAppCard from "./devices-app-card.jsx";
import DevicesPrincipalValidate from "./devices-principal-validate.jsx";
import DefaultHeader from "../../../utils/default-header.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";
import userService from "../../../../../../../services/web/user-service.js";
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import InputSwitch from "../../../../../../../components/input/input-switch.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const DevicesConfigModal = ({
    devices,
    setDevices,
    deviceSelected,
    open,
    setOpen,
    lanes,
    user,
    userId,
    myUser = false
}) => {
    const [validatedOpen, setValidatedOpen] = useState(false);

    const device = devices.find(c => c.id === deviceSelected) ?? {};

    const handleIsMain = () => {
        if (device?.type !== "CELULAR") return;

        let text = `Tornar ${projectUtils.formatPhone(device?.phone)} em principal?`;
        if (device?.main) text = `Remover ${projectUtils.formatPhone(device?.phone)} como principal?`;

        projectUtils.swalMessage(
            "warning",
            "Atenção",
            text,
            "Continuar",
            true,
            "Cancelar",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    if (!device?.main) {
                        setValidatedOpen(true);
                        setOpen(false);
                        return;
                    }

                    userService.unsetMain(userId, DefaultHeader)
                        .then(() => {
                            setDevices(prev => prev.map(p => ({...p, main: p.id === deviceSelected ? false : false})));
                        })
                        .catch(() => projectUtils.swalErrorMessage("", "Não foi possível prosseguir.", "Ok"))
                }
            }
        );
    };

    const closeValidateModal = () => {
        setValidatedOpen(false);
        setOpen(true);
    }

    const titleJsx = (
        <div className={"flex flex-col"}>
            <h3 className="font-bold m-0">{user.name}</h3>
            <div className="flex gap-4 mt-2 items-center">
                <h4>{projectUtils.formatPhone(device?.phone)}</h4>

                <InputSwitch
                    id="isMain"
                    label="Principal"
                    checked={device.main}
                    onChange={() => handleIsMain()}
                    title="Usar esse contato para autenticação de dois fatores e recuperação de senha"
                />
            </div>
        </div>
    )

    return (
        <>
            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} centered dialogClassName="config-modal" className="w-[65dvw]" title={titleJsx}>
                <Modal.Body className={"overflow-auto h-[calc(100vh-230px)]"}>
                    {
                        device?.type === "CELULAR" &&
                        <div className="grid grid-cols-2 gap-2 items-stretch">
                            <DevicesAppCard
                                target={"agent"}
                                title={"App Agente"}
                                authorized={device?.agentAuthorized}
                                dt_activation={device?.agentDtActivation}
                                device={device}
                                lanes={lanes}
                                icon={`img/sentry-apps/sentry-agente.png`}
                                setDevices={setDevices}
                                myUser={myUser}
                            />
                            <DevicesAppCard
                                target={"monitoramento"}
                                title={"App Alarmes"}
                                authorized={device?.monitoramentoAuthorized}
                                dt_activation={device?.monitoramentoDtActivation}
                                device={device}
                                icon={`img/sentry-apps/icon-alarmes.png`}
                                setDevices={setDevices}
                                myUser={myUser}
                            />
                            <DevicesAppCard
                                target={"despacho"}
                                title={"App Despacho"}
                                authorized={device?.despachoAuthorized}
                                dt_activation={device?.despachoDtActivation}
                                device={device}
                                icon={`img/sentry-apps/dispatch.png`}
                                setDevices={setDevices}
                                myUser={myUser}
                            />
                            <DevicesAppCard
                                target={"pcl"}
                                title={"App Captura Móvel"}
                                authorized={device?.pclAuthorized}
                                dt_activation={device?.pclDtActivation}
                                device={device}
                                lanes={lanes}
                                icon={`img/sentry-apps/captura.png`}
                                setDevices={setDevices}
                                myUser={myUser}
                            />
                            <DevicesAppCard
                                target={"abordagem"}
                                title={"App Abordagem"}
                                authorized={device?.abordagemAuthorized}
                                dt_activation={device?.abordagemDtActivation}
                                device={device}
                                icon={`img/sentry-apps/abordagem.png`}
                                setDevices={setDevices}
                                myUser={myUser}
                            />
                        </div>
                    }
                </Modal.Body>

                <Modal.Footer>
                    <Button target="secondary" onClick={() => setOpen(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            <DevicesPrincipalValidate
                open={validatedOpen}
                onClose={closeValidateModal}
                device={device}
                setDevices={setDevices}
            />
        </>
    );
};

export default DevicesConfigModal;